// Centralized site constants
export const SITE = {
  name: "Lotus Family Dental",
  tagline: "We Are Smile Specialists",
  shortDescription:
    "Best dental clinic in Allahabad (Prayagraj) offering painless, advanced dental care. Implants, root canal, braces, whitening and more.",
  phone: "+91 9407018052",
  phoneDigits: "919407018052",
  whatsappMessage: "Hi, I need a dental consultation.",
  email: "Dr.rahultiwarimds@gmail.com",
  address: "UG4 Ali Tower, MG Marg, Civil Lines, Prayagraj",
  city: "Prayagraj",
  state: "Uttar Pradesh",
  pincode: "211001",
  timings: "10 AM – 9 PM",
  daysOpen: "Mon - Sun",
  mapsUrl: "https://maps.app.goo.gl/BoGqU22ptkiW3oTp9",
  mapsEmbed:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3604.9023059186156!2d81.83003!3d25.4500!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399acac2f8a8f8bf%3A0x0!2sMG%20Marg%2C%20Civil[...])",
  social: {
    instagram: "#",
    facebook: "#",
    youtube: "#",
  },
  hero_image:
    "https://images.unsplash.com/photo-1606811971618-4486d14f3f99?w=1600&q=85",
};

export const ASSETS = {
  logo: "https://customer-assets.emergentagent.com/job_lotus-family-dental/artifacts/w0ba94vf_LOGO%20x%20png.png",
  // point to hyphenated, lowercase filenames (safer for deployment)
  drRahul:
    "https://i.ibb.co/Wvdb3yMV/Dr-Rahul2.png",
   // "/image/dr-rahul2.png",
  drMonika:
    "https://i.ibb.co/wNBYSYyw/Dr-monika2.png",
  drAanchal:
    "https://i.ibb.co/G30FGLDs/Dr-Aanchal.png",
  drKajal:
    "https://i.ibb.co/0j5mbKPy/Dr-Kajal.png",
  clinicWall:
    "https://customer-assets.emergentagent.com/job_3b60f41e-ab5d-4d3a-9503-b32ad4af217f/artifacts/96j3xesz_2025-07-14%20%282%29.webp",
  clinicEquipment:
    "https://customer-assets.emergentagent.com/job_3b60f41e-ab5d-4d3a-9503-b32ad4af217f/artifacts/7zym1ywq_2025-07-14.jpg",
  modernRoom1: "https://images.pexels.com/photos/5355921/pexels-photo-5355921.jpeg",
  modernRoom2: "https://images.unsplash.com/photo-1704455306251-b4634215d98f?w=1200&q=85",
  smilingPatient1: "https://images.pexels.com/photos/3845808/pexels-photo-3845808.jpeg",
  smilingPatient2: "https://images.unsplash.com/photo-1667133295308-9ef24f71952e?w=1200&q=85",
  dentistConsultation:
    "https://images.pexels.com/photos/14052564/pexels-photo-14052564.jpeg",
};

export const whatsappLink = (msg = SITE.whatsappMessage) =>
  `https://wa.me/${SITE.phoneDigits}?text=${encodeURIComponent(msg)}`;

export const callLink = `tel:${SITE.phone.replace(/\s/g, "")}`;

export const DOCTORS = [
  {
    name: "Dr. Rahul Tiwari",
    image: ASSETS.drRahul,
    qualifications: "BDS, MDS",
    titles: [
      "Orthodontist",
      "Dentofacial Orthopaedics Specialist",
      "Certified Osstem Implantologist",
      "Dental Implant Specialist",
      "Professor at RKDF Dental College (Bhopal)",
      "Ex. Dental Officer, Rashtriya Seva Yojana (Bhopal)",
      "Consultant Orthodontist, Prayagraj",
    ],
    specialty: "Orthodontist & Implantologist",
    bio:
      "Dr. Rahul Tiwari is an MDS-qualified orthodontist and implant specialist with experience in braces, clear aligners, and complex implant cases. He combines academic experience as a professor with hands-on clinical expertise.",
  },
  {
    name: "Dr. Monika Tiwari",
    image: ASSETS.drMonika,
    qualifications: "BDS, MDS (Gold Medalist)",
    titles: [
      "Pedodontist",
      "Root Canal Specialist & Smile Designer",
      "Professor at RKDF Dental College (Bhopal)",
      "Consultant Pedodontist, Arogyam Hospital",
      "Ex. Dental Officer, Rashtriya Seva Yojana (Bhopal)",
    ],
    specialty: "Pedodontist & Endodontist",
    bio:
      "Dr. Monika Tiwari (Gold Medalist) is a pedodontist and RCT specialist known for her gentle approach with children and expertise in smile design and restorative treatments.",
  },
  {
    name: "Dr. Aanchal",
    image: ASSETS.drAanchal,
    qualifications: "BDS, MDS",
    titles: ["Oral Pathologist"],
    specialty: "Oral Pathology",
    bio:
      "Dr. Aanchal is an MDS-qualified oral pathologist with expertise in diagnostic services and oral disease management. She supports clinical cases with histopathological diagnosis and multidisciplinary input.",
  },
  {
    name: "Dr. Kajal",
    image: ASSETS.drKajal,
    qualifications: "BDS",
    titles: ["General Dentist"],
    specialty: "General Dentistry",
    bio:
      "Dr. Kajal is a general dentist providing routine dental care, preventive services, and patient education to help maintain oral health across all ages.",
  },
];

export const WHY_CHOOSE_US = [
  {
    title: "Painless Treatment",
    description:
      "Modern anaesthesia & gentle techniques mean zero pain — even for nervous patients and children.",
    icon: "Heart",
  },
  {
    title: "Modern Technology",
    description:
      "Digital X-rays, RVG, intra-oral cameras, and Osstem implant systems — global-standard equipment.",
    icon: "Zap",
  },
  {
    title: "Experienced Doctors",
    description:
      "MDS specialists & associate professors with 10+ years of clinical and academic excellence.",
    icon: "GraduationCap",
  },
  {
    title: "Hygienic Environment",
    description:
      "Hospital-grade sterilization, autoclaved instruments, and single-use disposables for every patient.",
    icon: "ShieldCheck",
  },
  {
    title: "Affordable Pricing",
    description:
      "Transparent rates, EMI options, and the best value for premium implants and treatments in Allahabad.",
    icon: "BadgeIndianRupee",
  },
  {
    title: "Same-Day Emergency",
    description:
      "Tooth pain? Broken tooth? Walk-in appointments and emergency dental care available daily.",
    icon: "Clock",
  },
];

export const HOMEPAGE_FAQS = [
  {
    q: "Is root canal treatment painful?",
    a: "Modern root canal treatment is virtually painless. At Lotus Family Dental, we use precision rotary instruments and effective local anaesthesia — most patients say the procedure feels like a mild pressure but no sharp pain.",
  },
  {
    q: "What is the cost of dental implants in Allahabad?",
    a: "Dental implant cost in Allahabad starts from ₹18,000 per implant and can go up to ₹55,000 depending on the implant brand (Osstem, Nobel, Straumann), the need for bone grafting, and the complexity of the case.",
  },
  {
    q: "What is the best age for braces?",
    a: "The ideal age for braces is between 11 and 15 years when permanent teeth have erupted and the jaw is still developing. However, with modern clear aligners and ceramic braces, adults of any age can get successful orthodontic treatment.",
  },
  {
    q: "How do I choose the best dentist in Prayagraj?",
    a: "Look for an MDS qualified specialist, modern equipment (digital X-rays, RVG), strict sterilization protocols, transparent pricing, and good patient reviews. Lotus Family Dental ticks every box.",
  },
  {
    q: "How long does a root canal treatment take?",
    a: "A standard RCT is completed in 1–2 sittings of 45–60 minutes each. Single-sitting RCT is also available for selected cases. After the canal is cleaned and sealed, a crown is placed within 1–2 weeks.",
  },
  {
    q: "Is teeth whitening safe?",
    a: "Yes. Professional in-clinic teeth whitening at Lotus Family Dental is completely safe when performed by trained dentists. We use FDA-approved whitening gels and LED activation — giving reliable results with minimal sensitivity.",
  },
];
